export default function StatsBand() {
  const stats = [
    { num: "1286", label: "累计收录档案", icon: "ri-archive-2-line" },
    { num: "342", label: "覆盖人物", icon: "ri-user-star-line" },
    { num: "68", label: "专题合集", icon: "ri-stack-line" },
    { num: "12", label: "每日新增快讯", icon: "ri-flashlight-line" },
  ];
  return (
    <section className="border-b border-background-200 bg-accent-500/15">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-2 text-center">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                <i className={`${s.icon} text-xl`} />
              </span>
              <p className="font-display text-4xl font-black text-foreground-950 md:text-5xl">{s.num}</p>
              <p className="text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
        <p className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-foreground-500">
          数据为当前栏目收录进度示意。档案库以「公开信息 + 创作复盘」方式持续归档，只做客观整理，不对任何人作出事实性结论。
        </p>
      </div>
    </section>
  );
}